import React, { useState, useEffect } from 'react';
import AdminApp from './admin/pages/AdminApp';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Collection from './components/Collection';
import EyeTest from './components/EyeTest';
import About from './components/About';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function App() {
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    if (window.location.pathname.startsWith('/admin')) {
      setIsAdmin(true);
    }
  }, []);

  if (isAdmin) return <AdminApp />;

  return (
    <>
      <Navbar />
      <Hero />
      <Services />
      <Collection />
      <EyeTest />
      <About />
      <Testimonials />
      <Contact />
      <Footer />
    </>
  );
}
